import axios from 'axios';
import { getAuthToken } from '../auth-token';
import { clearAuthData, addToFailedQueue } from '../auth-event';

const baseURL =
  process.env.NEXT_PUBLIC_API_ANALYTICS_BASE_URL ||
  (process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
    ? 'https://analytics.clickster.io'
    : 'https://s-analytics.clickster.io');

/**
 * Axios instance for making requests to the analytics API.
 */
export const ANALYTICS = axios.create({
  baseURL,
  timeout: 60000, // 60 second timeout for all analytics requests
});

ANALYTICS.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Response interceptor to handle invalid or expired tokens.
 * Shows auth modal when 401 Unauthorized is detected
 * Queues failed requests for retry after login
 */
ANALYTICS.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    // Only handle 401 errors that haven't been retried yet
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Clear auth data from storage
      clearAuthData();

      // Queue the failed request and show auth modal
      return addToFailedQueue(originalRequest);
    }

    return Promise.reject(error);
  }
);
